import type { DateRange } from "@/models/common";
import type { FilterState } from "@/store/filters/state";

/**
 * Retrieve the datetime at which the date range was set from the filter module.
 * @param state - Vuex state for the Filter module.
 * @returns - The dateRange that indicates the start time and end time or undefined.
 */
export function getDateRange(state: FilterState): DateRange | undefined {
  return state.dateRange;
}

/**
 * Retrieve the string array at which the filters were added from the filter module.
 * @param state - Vuex state for the Filter module.
 * @returns - The string array that contains the filters or undefined.
 */
export function getFilters(state: FilterState): Array<string> | undefined {
  return state.filters;
}

/**
 * Retrieve a boolean value to know if filters are shareable
 * @param state - Vuex state for the Filter module.
 * @returns - boolean value, true if shareable
 */
export function getIsFilterShareable(state: FilterState): boolean {
  return state.isFilterShareable;
}
